export default function Sparkline({ data = [], width = 120, height = 32, color = '#2F6B47' }) {
    if (!data.length) return null;
    const values = data.map((d) => d.price ?? d.value ?? d);
    const min = Math.min(...values);
    const max = Math.max(...values);
    const range = max - min || 1;
    const step = width / (values.length - 1);
    const points = values.map((v, i) => {
        const x = i * step;
        const y = height - ((v - min) / range) * height;
        return `${x},${y}`;
    }).join(' ');
    const last = values[values.length - 1];
    const lx = (values.length - 1) * step;
    const ly = height - ((last - min) / range) * height;
    const rising = last >= values[0];
    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className="block">
            <polyline
                fill="none"
                stroke={rising ? '#0B8A3E' : '#C3341C'}
                strokeWidth="1.25"
                points={points}
                vectorEffect="non-scaling-stroke"
            />
            <circle cx={lx} cy={ly} r="2" fill={rising ? '#0B8A3E' : '#C3341C'} />
        </svg>
    );
}
